import React from 'react';
import { maClasseTabs, ElevesDashboardProf } from '../../types/classe/maClasse';
import { CompetenceTab } from './tabs/CompetencesTab';
import { QuizTab } from './tabs/QuizTab';
import { CarouselNav } from 'components/molecules/Carousel/CarouselNav';
import { carouselLoop } from 'helpers/carousel/carsouelLoop';
import { VentesTab } from './tabs/VentesTab';
import { ChallengeTab } from './tabs/ChallengeTab';
import pages from '../../routes/pages';
import { UpdateNote } from 'components/organisms/Contents/MyClassContent/UpdateNote';
import { MaClasseTab } from './tabs/MaClasseTab';
import { useMediaQuery } from 'hooks/useMediaQuery';
import { MobileTabLineInformations } from 'components/molecules/Table/MobileTabLine/MobileTabLineInformations';
import { MobileTabLineVentes } from 'components/molecules/Table/MobileTabLine/MobileTabLineVentes';
import { MobileTabLineChallenge } from 'components/molecules/Table/MobileTabLine/MobileTabLineChallenge';
import { MobileTabLineCompetences } from 'components/molecules/Table/MobileTabLine/MobileTabLineCompetences';
import { MobileTabQuiz } from 'components/organisms/Table/MobileTab/MobileTabQuiz';
import { ClasseDefWithUser } from '../../types/classe/classe.def';
import { FeatureClassManager } from '../../components/organisms/Features/FeatureClassManager';
import { TableDataNav } from '../../components/molecules/Nav/TableDataNav';
import { GoToPage } from '../../helpers/page/goToPage';
import { ControlTab } from './tabs/ControlTab';
import { ContainerFullWidth } from '../../components/layouts/ContainerFullWidth';
import { DownloadCSVButton } from 'components/atoms/Buttons/DownloadCSVButton';
import { BackButton } from 'components/molecules/Buttons/BackButton';

interface EspaceProfViewProps {
  users: ElevesDashboardProf[];
  setTab: (tab: number) => void;
  tab: number;
  csvData: object | null;
  toPage: GoToPage;
  classe: ClasseDefWithUser;
}

const EspaceProfView = ({
  users,
  setTab,
  tab,
  csvData,
  toPage,
  classe
}: EspaceProfViewProps) => {
  const isDesktop = useMediaQuery('desktop');
  const maClasseTabsLength = maClasseTabs.length;

  return (
    <>
      <BackButton text="Retourner sur Ma Classe" />
      <ContainerFullWidth>
        <FeatureClassManager classe={classe} />
        <div>
          {!isDesktop ? (
            <TableDataNav
              tabs={maClasseTabs}
              selected={tab}
              setSelected={setTab}
            />
          ) : (
            <CarouselNav
              isMobile={true}
              variant={
                maClasseTabs[tab].name === 'Contrôle des commandes'
                  ? 'danger'
                  : 'default'
              }
              text={maClasseTabs[tab].name}
              next={() => setTab(carouselLoop(tab + 1, maClasseTabsLength))}
              previous={() => setTab(carouselLoop(tab - 1, maClasseTabsLength))}
            />
          )}
          {!isDesktop && (
            <>
              {tab === 0 && <MaClasseTab classe={classe} toPage={toPage} />}
              {tab === 1 && (
                <VentesTab
                  numberOfCommandePaymentReminder={
                    classe.orderNeedToBeReminded
                      ? classe.orderNeedToBeReminded
                      : 0
                  }
                  eleves={users}
                  toElevePage={toPage(pages.COMMANDE_ELEVE_DETAILS.path)}
                />
              )}
              {tab === 2 && <ChallengeTab eleves={users} />}
              {tab === 3 && <CompetenceTab eleves={users} />}
              {tab === 4 && <QuizTab eleves={users} />}
            </>
          )}
          {isDesktop && (
            <div style={{ marginTop: '20px' }}>
              {tab === 0 && (
                <MobileTabLineInformations classe={classe} toPage={toPage} />
              )}
              {tab === 1 && (
                <MobileTabLineVentes
                  numberOfCommandePaymentReminder={
                    classe.orderNeedToBeReminded
                      ? classe.orderNeedToBeReminded
                      : 0
                  }
                  eleves={users}
                  toElevePage={toPage(pages.COMMANDE_ELEVE_DETAILS.path)}
                />
              )}
              {tab === 2 && <MobileTabLineChallenge eleves={users} />}
              {tab === 3 && <MobileTabLineCompetences eleves={users} />}
              {tab === 4 && <MobileTabQuiz eleves={users} />}
            </div>
          )}
          {tab === 5 && <ControlTab />}
        </div>
        {(tab === 0 || tab === 1 || tab === 2 || tab === 3) && (
          <DownloadCSVButton
            title={`Téléchargez le tableau ${maClasseTabs[tab].name} en .CSV`}
            fileName={`${maClasseTabs[tab].name
              .replaceAll(' ', '-')
              .toUpperCase()}-${classe.name
              .replaceAll(' ', '-')
              .toUpperCase()}`}
            file={csvData && csvData}
          />
        )}
        <UpdateNote />
      </ContainerFullWidth>
    </>
  );
};

export default EspaceProfView;
